import { gsap } from 'gsap';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { lg, md, xl } from '../common';

export function initPower() {
  const parent = document.querySelector('.power');
  if (!parent) return;

  new Swiper('.power__swiper', {
    modules: [Pagination],
    slidesPerView: 'auto',
    spaceBetween: 12,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [lg]: {
        enabled: false,
        slidesPerView: 'auto', // removes slide width
        spaceBetween: 0, // removes margin-right
      },
    },
  });

  const cards = parent.querySelectorAll('.power__card');
  cards.forEach((card) => {
    gsap.fromTo(
      card,
      { autoAlpha: 0, scale: 0.9, y: 10 },
      {
        autoAlpha: 1,
        scale: 1,
        y: 0,
        scrollTrigger: { trigger: card, start: 'top bottom-=200' },
      },
    );
  });
}
